import React from "react";
import { PeopleManager } from "@/components/account/PeopleManager";

export const PeoplePage: React.FC = () => (
  <PeopleManager asPage headingLevel={1} />
);
